import React, { ReactNode, useContext, useEffect } from 'react';
import { Header } from '../Header';
import { Footer } from '../Footer';
import styled, { createGlobalStyle } from 'styled-components';
import { SiteContext } from '../../context';
import { useStaticQuery, graphql } from 'gatsby';

interface GSProps {
  theme?: any;
}
const GlobalStyles = createGlobalStyle`

body, html{
  font-family: ${({ theme }: any) => theme.fontFamily};
  color: ${({ theme }: any) => theme.text};
  line-height: 1.6rem;
  background-color: ${({ theme }: any) => theme.background};
  font-size: 100%;
  margin: 0;
}
a{ 
  color: ${({ theme }: any) => theme.primary};
  text-decoration: none;
  &:hover{
    filter: brightness(0.6);

  }
}
p a{
  text-decoration:underline;
}

pre[class*="language-"]{
    white-space: pre-wrap;
    overflow: scroll;
}
`;
const StyledLayout = styled.div`
  display: grid;
  max-width: 1160px;
  margin: 0 auto;
  padding: 0 10px;
  grid-template-rows: 50px auto 50px;
  gap: 20px;
  box-sizing: border-box;
`;

const StyledMain = styled.main`
  margin-top: 40px;
  margin-bottom: 40px;
`;
interface Props {
  children: ReactNode;
}
const Layout = ({ children }: Props) => {
  const { dispatch } = useContext(SiteContext);
  const query = useStaticQuery(graphql`
    query getStoriDataColor {
      storiThemeData {
        themeColor
      }
    }
  `);
  const { themeColor } = query.storiThemeData;

  useEffect(() => {
    const localThemeColor = window.localStorage.getItem('stori_theme_color');
    const localThemeMode = window.localStorage.getItem('stori_theme_mode');

    dispatch({
      type: 'SET_THEME',
      payload: localThemeColor ? localThemeColor : themeColor,
    });

    dispatch({
      type: 'SET_THEME_MODE',
      payload: localThemeMode ? localThemeMode : 'light',
    });
    window.localStorage.setItem(
      'stori_theme_color',
      localThemeColor ? localThemeColor : themeColor
    );
  }, []);
  return (
    <StyledLayout>
      <GlobalStyles />
      <Header />
      <StyledMain>{children}</StyledMain>
      <Footer />
    </StyledLayout>
  );
};

export default Layout;
